


















import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import EasingGui from './EasingGui.vue'
import {
  EasingPoints,
  EasingStatus,
  easingStatusGroups,
  getEasingCubicBezierPoints
} from './easing-status.interface'

@Component({
  components: {
    EasingGui
  }
})
export default class EasingDefaults extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => [0.4, 0.1, 0.4, 0.8]
  })
  value!: EasingPoints

  private easingStatusGroups: EasingStatus[][] = easingStatusGroups

  get easingPointsGroups(): EasingPoints[][] {
    return easingStatusGroups.map(easingStatusGroup =>
      easingStatusGroup.map(easingStatus =>
        getEasingCubicBezierPoints(easingStatus)
      )
    )
  }

  isActive(easingPointsGroup: EasingPoints[]): boolean {
    return easingPointsGroup.some(easingPoints =>
      easingPoints.every((point, index) => point === this.value[index])
    )
  }

  @Emit()
  onChangeEasingPoints(easingPoints: EasingPoints): EasingPoints {
    return easingPoints
  }
}
